import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, createSearchParams } from "react-router-dom";
import axios from "axios";
import { paymentBaseUrl } from "../../constant";
import "../../pages/paymentPage.css";
import { Box, Button, Card, CardContent, TextField } from "@mui/material";
import successpic from "../../assets/images/success.png";
import successMarketing from "../../assets/images/successMarketing.png";
import sandbox from "../../assets/images/sandbox.png";
import error from "../../assets/images/error.png";
import failedStatus from "../../assets/images/faileMarketing.svg";
import googleplay from "../../assets/images/googleplay.png";
import appstore from "../../assets/images/appstore.png";
import pendingMarketing from "../../assets/images/pendingMarketing.png";
import {  homeUrl } from "../../constant";
import Header from "../../components/Header";
import { useLayoutEffect } from "react";
import { Footer } from "../../components/Footer";
import styled from "@emotion/styled";
import DataServices from "../../components/DataServices";
import { useGlobalState } from "../../globalStyle";

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

const isTenDigits = (str) => {
  return /^\d{10}$/.test(str);
}

const PaymentResult = () => {
  const [width, height] = useWindowSize();
  const params = useParams();
  const [status, setStatus] = useState({});
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isFlutterView, setIsWebView] = useState(true);
  const [isKyc, setIsKyc] = useState(true);
  const [planDetails, setPlanDetails] = useState("");
  const [countdown, setCountdown] = useState(10); // Countdown timer in seconds
  const [isCountdownFinished, setIsCountdownFinished] = useState(false);
  const [productData, setProductData] = useState([]);
  const [formWidth, setFormWidth] = useState('');
  const intervalRef = useRef(null);
  const [isPendingStatus, setIsPendingStatus] = useState(false);
  const [myHtml, setMyHtml] = useState('');
  const paymentBaseUrl = useGlobalState("PAYMENTBASEURL")[0];
  const verifyUsers = useGlobalState("VERIFYUSERS")[0];
  const authorizereqUrl = useGlobalState("AUTHORIZEREQURL")[0];



  useEffect(() => {
    if (status.status === "PENDING") {
      setIsPendingStatus(true);
      const intervalId = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
        if (countdown <= 0) {
          clearInterval(intervalId); // Stop calling API after 5 seconds
        } else {
          checkPaymentStatus();
        }
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [countdown, status]);


  const isCustomFormat = window.location.search.includes("formattype=custom");

  const checkPaymentStatus = async () => {
    try {
      const data = await DataServices.checkPaymentStatus(params,paymentBaseUrl);
      if (data) {
        setStatus(data);
        if (data.status === "PENDING") {
          <Pending />
        } else {
          setIsLoading(false);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };



  const fetchPaymentOrder = async (orderId) => {
    try {
      const { data } = await axios.get(`${paymentBaseUrl}/api/payments/order/${orderId}`);

      if (!data) return;

      setProductData(data);

      const paymentData = data.data[0];
      if (!paymentData) return;

      const productId = paymentData.product_id;
      const productResponse = await axios.get(`${paymentBaseUrl}/products`);
      const products = productResponse?.data?.products || [];

      const childMatchingProduct = products.flatMap(item => (item.child ? item.child : [])).find(child => child.code === productId);
      const campaignMatchingProduct = products.flatMap(item => (item.campaigns ? item.campaigns : [])).find(child => child.code === productId);

      if (isTenDigits(paymentData.client_code)) {
        const authorizeToken = await DataServices.authorizeUserRequest(authorizereqUrl);
        const response = await fetch(verifyUsers, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authorizeToken.data.id_token}`,
          },
          body: JSON.stringify({
            "taskcode": "101",
            "entitycode": "502",
            "body": {
              "mob": paymentData.client_mobile,
            },
          }),
        });

        const userData = await response.json();
        if (Array.isArray(userData) && userData.length > 0) {
          setIsKyc(userData[0].isKYCCompleted === true);          
        } else {
          setIsKyc(false);
        }
      }

      if (childMatchingProduct) {
        const msg =
          paymentData.status === "FAILED" ? childMatchingProduct.summaryHeaderText.failedMessage :
            paymentData.status === "SUCCESS" ? childMatchingProduct.summaryHeaderText.successMessage :
              childMatchingProduct.summaryHeaderText.pendingMessage;

        setMyHtml(msg);
        setPlanDetails(childMatchingProduct);

      } else {
        const msg =
          paymentData.status === "FAILED" ? campaignMatchingProduct.summaryHeaderText.failedMessage :
            paymentData.status === "SUCCESS" ? campaignMatchingProduct.summaryHeaderText.successMessage :
              campaignMatchingProduct.summaryHeaderText.pendingMessage;

        setMyHtml(msg);
        setPlanDetails(campaignMatchingProduct);

      }
    } catch (error) {
      console.error("Error fetching payment order:", error);
    }
  };

  useEffect(() => {
    checkPaymentStatus();
    if (params.id && authorizereqUrl) {
      fetchPaymentOrder(params.id);
    }

    return () => {
      clearTimeout(intervalRef.current);
    }
  }, [params.gateway, params.method, params.id,authorizereqUrl]);

  // const afterPaymentInitialApi = async (response) => {
  //   const initialLeadSquaredBody = [
  //     {
  //       "Attribute": "Phone",
  //       "Value": response.data[0].client_mobile
  //     },
  //     {
  //       "Attribute": " EmailAddress",
  //       "Value": response.data[0].client_email
  //     },
  //     {
  //       "Attribute": " SearchBy",
  //       "Value": " Phone"
  //     }
  //   ];

  //   const result = await DataServices.afterPaymentInitialLeadSquared(initialLeadSuqaredUrl, initialLeadSquaredBody);
  //   if (result) {
  //     afterPaymentPostApi(result, response.data[0]);
  //   }
  // }

  // const afterPaymentPostApi = async (val, response) => {
  //   const leadSquaredPostData = {
  //     "RelatedProspectId": val.Message.RelatedId,
  //     "ActivityEvent": 254,
  //     "ActivityNote": "Product Subscription",
  //     "ActivityDateTime": moment().format('YYYY-MM-DD HH:mm:ss'),
  //     "Fields": [
  //       {
  //         "SchemaName": "mx_Custom_1",
  //         "Value": val.Message.product_id
  //       },
  //       {
  //         "SchemaName": "mx_Custom_2",
  //         "Value": val.Message.discount
  //       },
  //       {
  //         "SchemaName": "mx_Custom_3",
  //         "Value": "2023-09-30 00:00:00"
  //       },
  //       {
  //         "SchemaName": "mx_Custom_4",
  //         "Value": "2023-09-13 00:00:00"
  //       },
  //       {
  //         "SchemaName": "mx_Custom_5",
  //         "Value": "Subscribed"
  //       },
  //       {
  //         "SchemaName": "mx_Custom_6",
  //         "Value": "Success"
  //       },
  //       {
  //         "SchemaName": "mx_Custom_7",
  //         "Value": val.Message.payment_type
  //       }
  //     ]
  //   }
  //   const result = await DataServices.afterPaymentInitialLeadSquared(afterPaymentleadSquaredUrl, leadSquaredPostData);
  // }

  useEffect(() => {
    if (
      typeof window != "undefined" &&
      typeof window.flutter_web_browser != "undefined" &&
      typeof window.flutter_web_browser.callHandler === "function"
    ) {
      setIsWebView(true);
    }
  }, [isFlutterView]);

  useEffect(() => {
    if (width > 1150) {
      setFormWidth('50%');
    } else {
      setFormWidth('100%')
    }
  }, [width])

  const handleViewPlan = async () => {
    if (
      typeof window != "undefined" &&
      typeof window.flutter_web_browser != "undefined" &&
      typeof window.flutter_web_browser.callHandler === "function"
    ) {
      window.flutter_web_browser.callHandler("handlerBackWithArgs", {
        back: 1,
      });
    } else {
      console.log("Flutter InAppWebView is not available");
      navigate("/");
    }
  };

  const Success = () => {
    return (
      <>
        <div>
          {
            isCustomFormat ? <>
              <div className="success-icon">
                <img height="50%" width="45%" src={successMarketing} alt="success" />
              </div>
            </> : <div className="success-icon">
              <img src={successpic} alt="success" />
            </div>
          }
          <div style={{ paddingLeft: `${width > 750 ? '10%' : ''}`, paddingRight: `${width > 750 ? '10%' : ''}` }}>
            {
              isCustomFormat ? <>
                <div dangerouslySetInnerHTML={{ __html: myHtml }} />

                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
                  <button onClick={() => openGooglePlayURL()} style={{ border: 'none', background: 'none', padding: 0 }}>
                    <img
                      src={googleplay}
                      alt="Google Play"
                      style={{ width: '150px', height: 'auto', imageRendering: 'auto' }}
                    />
                  </button>
                  <button onClick={() => openAppStoreURL()} style={{ border: 'none', background: 'none', padding: 0 }}>
                    <img
                      src={appstore}
                      alt="App Store"
                      style={{ width: '150px', height: 'auto', imageRendering: 'auto' }}
                    />
                  </button>
                </div>

                {planDetails.productCode === "PROTIPS" && <div>
                  <div className="protip-zero">ZERO Brokerage</div>
                  <div className="protip-zero-description">
                    StoxCalls subscribers pay zero brokerage when they trade on StoxBox platforms. Complete your KYC now to start trading with zero brokerage fees.</div>
                </div>}
                {!isKyc &&
                  <div className="home">
                    <Button
                      onClick={() => openKycPage()}
                      variant="contained"
                      style={{ width: "210px" }}
                      className={isCountdownFinished && status.status === "PENDING" ? 'shake-effect' : ''}
                    >
                      Complete Your KYC
                    </Button>
                  </div>
                }
              </> : <>
                <div className="success-title">Congratulations!</div>
                <p className="success-text-static">Successfully subscribed to {planDetails.plan}. <br /> Start trading smartly.</p>
              </>
            }

            {
              isCustomFormat ? <>
                <legend style={{ textAlign: 'center', color: '#563eec', fontSize: '14px', paddingTop: '12px', fontWeight: 'bold' }}>Your Payment ID</legend>
                <Box component="fieldset" style={{ border: '2px solid #e0e0e0', borderRadius: '5px' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '5px', fontWeight: 'bold' }}><p>{params.id}</p></div>
                </Box>
                <p className="future-reference">(Keep for future reference)</p>
                {planDetails.productCode !== "PROTIPS" && <div style={{ textAlign: 'center', fontSize: '12px' }}>
                  <p><span style={{ fontWeight: 'bold' }}>Note :</span> If {planDetails.plan} is not enabled and your funds is debited, please go to My Subscription section from Accounts and click on refresh to know your plan details.</p>
                </div>}
              </> : <>
                <div className="order-text-paymentid">
                  Your Payment ID
                </div>
                <div
                  className="order-number" >
                  {params.id}
                </div>
                <p className="future-reference">(Keep for future reference)</p>
                {!isKyc &&
                  <div className="home">
                    <Button
                      onClick={() => openKycPage()}
                      variant="contained"
                      style={{ width: "210px" }}
                      className={isCountdownFinished && status.status === "PENDING" ? 'shake-effect' : ''}
                    >
                      Complete Your KYC
                    </Button>
                  </div>

                }
                {planDetails.productCode !== "PROTIPS" && <div style={{ textAlign: 'center', fontSize: '12px', marginTop: '5px' }}>
                  <p><span style={{ fontWeight: 'bold' }}>Note :</span> If  {planDetails.plan} is not enabled and your funds is debited, please go to My Subscription section from Accounts and click on refresh to know your plan details.</p>
                </div>}
              </>
            }
          </div>
        </div>
      </>
    );
  }

  const SuccessSettlement = () => {
    return (
      <>
        <div>
          {
            isCustomFormat ? <>
              <div className="success-icon">
                <img height="50%" width="45%" src={successMarketing} alt="success" />
              </div>
            </> : <div className="success-icon">
              <img src={successpic} alt="success" />
            </div>
          }
          <div style={{ paddingLeft: `${width > 750 ? '10%' : ''}`, paddingRight: `${width > 750 ? '10%' : ''}` }}>
            {
              isCustomFormat ? <>
                <div dangerouslySetInnerHTML={{ __html: myHtml }} />

                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
                  <button onClick={() => openGooglePlayURL()} style={{ border: 'none', background: 'none', padding: 0 }}>
                    <img
                      src={googleplay}
                      alt="Google Play"
                      style={{ width: '150px', height: 'auto', imageRendering: 'auto' }}
                    />
                  </button>
                  <button onClick={() => openAppStoreURL()} style={{ border: 'none', background: 'none', padding: 0 }}>
                    <img
                      src={appstore}
                      alt="App Store"
                      style={{ width: '150px', height: 'auto', imageRendering: 'auto' }}
                    />
                  </button>
                </div>

                {planDetails.productCode === "PROTIPS" && <div>
                  <div className="protip-zero">ZERO Brokerage</div>
                  <div className="protip-zero-description">
                    StoxCalls subscribers pay zero brokerage when they trade on StoxBox platforms. Complete your KYC now to start trading with zero brokerage fees.</div>
                </div>}
                {!isKyc &&
                  <div className="home">
                    <Button
                      onClick={() => openKycPage()}
                      variant="contained"
                      style={{ width: "210px" }}
                      className={isCountdownFinished && status.status === "PENDING" ? 'shake-effect' : ''}
                    >
                      Complete Your KYC
                    </Button>
                  </div>
                }
              </> : <>
                <div className="success-title">Congratulations!</div>
                <p className="success-text-static">Your payment is successfully completed.</p>
              </>
            }

            {
              isCustomFormat ? <>
                <legend style={{ textAlign: 'center', color: '#563eec', fontSize: '14px', paddingTop: '12px', fontWeight: 'bold' }}>Your Payment ID</legend>
                <Box component="fieldset" style={{ border: '2px solid #e0e0e0', borderRadius: '5px' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '5px', fontWeight: 'bold' }}><p>{params.id}</p></div>
                </Box>
                <p className="future-reference">(Keep for future reference)</p>
                {planDetails.productCode !== "PROTIPS" && <div style={{ textAlign: 'center', fontSize: '12px' }}>
                  <p><span style={{ fontWeight: 'bold' }}>Note :</span> If {planDetails.plan} is not enabled and your funds is debited, please go to My Subscription section from Accounts and click on refresh to know your plan details.</p>
                </div>}
              </> : <>
                <div className="order-text-paymentid">
                  Your Payment ID
                </div>
                <div
                  className="order-number" >
                  {params.id}
                </div>
                <p className="future-reference">(Keep for your future reference)</p>
                {/* {!isKyc &&
                  <div className="home">
                    <Button
                      onClick={() => openKycPage()}
                      variant="contained"
                      style={{ width: "210px" }}
                      className={isCountdownFinished && status.status === "PENDING" ? 'shake-effect' : ''}
                    >
                      Complete Your KYC
                    </Button>
                  </div>

                } */}
                {planDetails.productCode !== "PROTIPS" && <div style={{ textAlign: 'center', fontSize: '12px', marginTop: '5px' }}>
                  <p><span style={{ fontWeight: 'bold' }}>Note :</span> If you encounter any issues or have questions please feel free to contact our dedicated support team at <a href={`mailto:support@stoxbox.in?subject=Payment ID: ${params.id}`}>support@bpwealth.com</a> or +919152928550. They will be happy to assist you and provide any necessary clarification.</p>
                </div>}
              </>
            }
          </div>
        </div>
      </>
    );
  }


  const Failed = () => {
    const handleRetryPayment = () => {
      if (productData.data) {
        const { product_id, client_email, client_mobile, client_code, client_name, client_details, product_code, payment_type, gateway } = productData.data && productData.data[0];
        const req = {
          product_plan_id: product_id.replace("PROTIPS", "STOXCALLS") || "",
          client_email: client_email || "",
          mobile: client_mobile || "",
          clientCode: client_code || "",
          gst: "",
          first_name: client_name || "",
          address: client_details.address || "",
          city: client_details.city || "",
          pincode: client_details.pincode || "",
          state: client_details.state || "",
          logo: false,
          productCode: product_code || "",
          return_url: isCustomFormat ? `${homeUrl}/payment/${payment_type.trim().toLowerCase()}/${gateway.trim().toLowerCase()}?formattype=custom` : `${homeUrl}/payment/${payment_type.trim()}/${gateway.trim().toLowerCase()}`,
          formattype: isCustomFormat ? 'custom' : ""
        };
        navigate({
          pathname: productData.data[0].product_id === "MENTORBOX_SETTLEMENT_PLAN" ? '/settlement' : '/details',
          search: `?${createSearchParams({ ...req, paymentMethod: payment_type.trim().toLowerCase(), paymentGateway: gateway.trim().toLowerCase() })}`,
        });
      }
    };
    return (
      <div>
        {
          isCustomFormat ? <>
            <div className="success-icon">
              <img height="50%" width="45%" src={failedStatus} alt="" />
            </div>
          </> : <>
            <div className="success-icon">
              <img height="120px" width="120px" src={error} alt="" />
            </div>
          </>
        }

        <div style={{ paddingLeft: `${width > 750 ? '20%' : ''}`, paddingRight: `${width > 750 ? '20%' : ''}` }}>
          {
            isCustomFormat ? <>
              <div dangerouslySetInnerHTML={{ __html: myHtml }} />
            </> : <>
              <div className="success-title">Your payment has failed!</div>
              <div className="success-description">
                Don't worry, your money is safe! If money is debited from your account,
                it will be refunded automatically in 5-7 working days.
              </div>
            </>
          }

          {
            isCustomFormat ? <>
              <div className="failed-description-contact">
                Reach us:&nbsp;
                <a href={`mailto:support@stoxbox.in?subject=Payment ID: ${params.id}`} style={{ textDecoration: 'none', borderBottom: '1px solid white' }}>
                  support@stoxbox.in
                </a>
              </div>

            </> : <>
              <div className="success-description">
                Contact us:&nbsp;
                <a href={`mailto:support@stoxbox.in?subject=Payment ID: ${params.id}`}>
                  support@stoxbox.in
                </a>
              </div>
            </>
          }

          {
            isCustomFormat ? <>
              <legend className="failed-legend">Your Payment ID</legend>
              <Box component="fieldset" style={{ border: '2px solid #e0e0e0', borderRadius: '5px' }}>
                <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '5px', fontWeight: 'bold' }}><p>{params.id}</p></div>
              </Box>
              <p className="future-reference">(Keep for future reference)</p>

              {
                isCustomFormat ? <>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <Button fullWidth variant="contained" onClick={handleRetryPayment} sx={{ textTransform: 'none', background: '#563EEC', fontSize: '16px' }}>Retry Payment</Button>
                  </div>
                </> : <>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <Button variant="contained" onClick={handleRetryPayment} sx={{ textTransform: 'none', background: '#563EEC', fontSize: '16px' }}>Retry Payment</Button>
                  </div>
                </>}
            </> : <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  color: "#666666",
                }}
              >
                Your Payment ID
              </div>
              <div
                className="order-number"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: 700,
                  // color: "#666666",
                }}
              >
                {params.id}
              </div>
              {/* Add the Retry Payment button */}
              <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <Button variant="contained" onClick={handleRetryPayment} sx={{ textTransform: 'none', background: '#563EEC' }}>Retry Payment</Button>
              </div>
            </>
          }
        </div>
      </div>
    )
  }

  const Pending = () => {
    return (
      <div>
        {
          isCustomFormat ? null : <>
            <div className="countdown-timer success-description" style={{ textAlign: 'center', margin: '10px 0px', fontSize: '14px' }}>
              {countdown <= 0 ? (
                <div>
                  <p>Your payment is still getting processed. Kindly wait while we get confirmation.</p>
                  <span style={{ display: 'block', textAlign: 'center' }}>OR</span>
                  <span style={{ display: 'block', textAlign: 'center', color: 'blue', cursor: 'pointer', marginTop: '10px' }} onClick={redirectPage}>Click here go to main page</span>
                </div>
              ) : <span style={{ display: 'block', textAlign: 'center' }}>Waiting for payment confirmation <b>{countdown}</b> sec</span>}
            </div>
          </>
        }

        <div style={{ paddingLeft: `${width > 750 ? '20%' : ''}`, paddingRight: `${width > 750 ? '20%' : ''}` }}>
          {
            isCustomFormat ? <>
              <div className="pending-title-custom">Payment Processing!</div>
            </> : null
          }

          {
            isCustomFormat ? <>
              <div className="pending-description-custom">Kindly wait while we get confirmation</div>
              <div className="pending-description-custom2">Your payment is getting processed</div>
              <div className="pending-description-custom3">OR</div>
            </> : null
          }

          {
            isCustomFormat ? <>
              <div className="success-description-contact">
                Reach us:&nbsp;
                <a href={`mailto:support@stoxbox.in?subject=Payment ID: ${params.id}`} style={{ textDecoration: 'none', borderBottom: '1px solid white' }}>
                  support@stoxbox.in
                </a>
              </div>

            </> : null
          }

          {
            isCustomFormat ? <>
              <legend style={{ textAlign: 'center', color: '#f9a451', fontSize: '14px', paddingTop: '5px', fontWeight: 'bold' }}>Your Payment ID</legend>
              <Box component="fieldset" style={{ border: '1px solid #e0e0e0', borderRadius: '5px' }}>
                <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '5px', fontWeight: 'bold' }}><p>{params.id}</p></div>
              </Box>
            </> : <>
              <div className="order-details">
                <div className="order-number-label">Your Payment ID</div>
                <div className="order-number">{params.id}</div>
              </div>
            </>
          }
        </div>
      </div>
    )
  }



  const redirectPage = () => {
    isFlutterView ? handleViewPlan() : window.open(homeUrl, "_self");
  };


  const openGooglePlayURL = () => {
    const url = "https://play.google.com/store/apps/details?id=com.bpwealth.stoxbox&hl=en_IN&gl=US";
    window.open(url, "_blank");
  };

  const openAppStoreURL = () => {
    const url = "https://apps.apple.com/us/app/stoxbox/id1597988143";
    window.open(url, "_blank");
  };

  const openKycPage = () => {
    const url = `https://ekyc.stoxbox.in/?utm_source=google&utm_medium=evolute_search&utm_campaign=branded_unlimited_calls&utm_content=unlimited-calls&name=${productData && productData.data[0].client_name}&mobile=${productData && productData.data[0].client_mobile}&mail=${productData && productData.data[0].client_email}&otpverified=true&otp=123456&mailverified=false&mailotp=`;
    window.open(url, "_blank");
  };

  return (
    <div style={{
      width: formWidth,
      margin: '30px auto',
      padding: '0 12px', /* Add padding for better mobile experience */
    }}>
      {/* <NavBar /> */}
      {isCustomFormat ? <Header title="Get unbiased stock recommedations at Zero Brokerage to Trade Successfully" /> : null}
      <Card>
        <CardContent>
          <div className="main-contents">

            {
              isCustomFormat && status.status === "PENDING" ? <>
                <div className="success-icon">
                  <img height={width > 450 ? '50%' : '95%'} width={width > 450 ? '45%' : '90%'} src={pendingMarketing} alt="" />
                </div>
              </> : null
            }

            {
              isCustomFormat ? null : <>
                {
                  isPendingStatus && <div className="progress-bar-container">
                    <div
                      className="progress-bar"
                    ></div>
                    <div className="progress-text">
                      <img height='25px' width='25px' src={sandbox} alt="" />
                    </div>
                  </div>
                }
              </>
            }

            {status.status === "SUCCESS" && productData && productData.data && productData.data.length > 0 && (
              productData.data[0].product_id === "MENTORBOX_SETTLEMENT_PLAN" ? <SuccessSettlement /> : <Success />
            )}
            {status.status === "PENDING" && (
              <Pending />
            )}
            {status.status === "FAILED" && (
              <Failed />
            )}
          </div>
          {isFlutterView ? (
            null
          ) : <div className="home" style={{ marginBottom: '20px' }}>
            <Button
              onClick={() => handleViewPlan()}
              variant="contained"
              style={{ width: "210px" }}
              className={isCountdownFinished && status.status === "PENDING" ? 'shake-effect' : ''}
            >
              View your plan
            </Button>
          </div >}
        </CardContent>
      </Card>
      {isCustomFormat && <Footer />}
    </div>
  );
};

export default PaymentResult;
